export default "__VITE_ASSET__h2klPfvx__"